import { useEffect, useState } from 'react';
import BetPlacementToast from '@/components/common/BetPlacementToast';
import type { BetPlaceResponse } from '@/types/betPlace';

export const BET_PLACEMENT_TOAST_EVENT = 'bet-placement-toast';

export interface BetPlacementToastPayload {
  response?: BetPlaceResponse;
  message: string;
  type: 'success' | 'error';
}

export const showBetPlacementToast = (payload: BetPlacementToastPayload) => {
  window.dispatchEvent(
    new CustomEvent<BetPlacementToastPayload>(BET_PLACEMENT_TOAST_EVENT, {
      detail: payload,
    })
  );
};

export default function BetPlacementToastHost() {
  const [toast, setToast] = useState<BetPlacementToastPayload | null>(null);

  useEffect(() => {
    const handleToast = (event: Event) => {
      setToast((event as CustomEvent<BetPlacementToastPayload>).detail);
    };

    window.addEventListener(BET_PLACEMENT_TOAST_EVENT, handleToast);

    return () => {
      window.removeEventListener(BET_PLACEMENT_TOAST_EVENT, handleToast);
    };
  }, []);

  useEffect(() => {
    if (!toast) return;

    const timeout = window.setTimeout(() => setToast(null), 4000);

    return () => window.clearTimeout(timeout);
  }, [toast]);

  if (!toast) return null;

  return (
    <div className="fixed bottom-0 left-1/2 z-[1200] w-full max-w-[30rem] -translate-x-1/2">
      <BetPlacementToast {...toast} onClose={() => setToast(null)} />
    </div>
  );
}
